type AggregateFunction = (values: any[]) => number | string | null;

class Constants {

    static DEFAULT_BUYER_FILTERS_ID = {
        BUYER_ORDERS:                'buyer:orders',
        BUYER_PREORDERS:             'buyer:preorders',
        BUYER_TENDERS:               'buyer:tenders',
        BUYER_DEMANDS:               'buyer:demands',
        BUYER_TENDERS_PARTICIPATION: 'buyer:tender-participation',

        BUYER_PAYMENT_REQUESTS: 'buyer:payment-requests',
        BUYER_DEMANDSV2:        'buyers:demandsV2'
    };

  /**
   * Варианты выравнивания текста
   */
  static readonly TEXT_ALIGNS = ["left", "center", "right"] as const;

  /**
   * Варианты выравнивания текста
   */
  static readonly VERTICAL_ALIGNS = ["baseline", "bottom", "middle", "top"] as const;

  /**
   * Варианты вывода контрола с лейблом.
   */
  static readonly CONTROL_LAYOUTS = ["horizontal", "vertical"] as const;

  /**
   * Регулярное выражение для валидации размеров css - 100px, 10%, 1vh и т.д.
   */
  static readonly CSS_SIZE_REGEXP = /[0-9]{2,4}[a-z%]{1,3}/i;

  /**
   * Методы агрегации данных. Принимает массив значений, возвращает число/строку
   */
  static readonly AGGREGATE_METHODS: Record<string, AggregateFunction> = {
    sum: (values: any[]): number => {
      if (!Array.isArray(values) || values.length === 0) return 0;
      let sum = 0;
      values.map((v) => {
        let value = 0;
        if (v !== null) {
          if (typeof v === "string") {
            value = parseFloat(v.replace(/[,]+/g, "."));
          } else if (typeof v === "number") {
            value = parseFloat(v);
          }
        }
        sum += isNaN(value) ? 0 : value * 100;
      });
      return sum / 100;
    },
  };

  /**
   * Список тем кнопки
   */
  static readonly BUTTON_THEMES = ["default", "primary", "flat", "link", "danger"] as const;

  /**
   * Список допустимых триггеров для VPopover.
   */
  static readonly POPOVER_TRIGGERS = ["hover-popup", "hover", "click", "none"] as const;

  /**
   * Список возможных позиций для VPopup
   */
  static readonly POPUP_POSITIONS = ["top", "right", "bottom", "left"] as const;

  /**
   * Список возможных выравниваний по вертикали для VPopup
   */
  static readonly POPUP_VALIGNS = ["auto", "top", "middle", "bottom"] as const;

  /**
   * Список возможных выравниваний по горизонтали для VPopup
   */
  static readonly POPUP_ALIGNS = ["auto", "left", "middle", "right"] as const;

}

export default Constants;



/**
 * Экспортируемые типы для удобного использования в компонентах.
 *
 * Эти типы извлекают union типы из readonly массивов констант.
 * Например, TextAlign = "left" | "center" | "right"
 *
 * Использование:
 * function alignText(align: TextAlign) { ... }
 *
 * Вместо:
 * function alignText(align: typeof Constants.TEXT_ALIGNS[number]) { ... }
 */
export type TextAlign = typeof Constants.TEXT_ALIGNS[number];
export type VerticalAlign = typeof Constants.VERTICAL_ALIGNS[number];
export type ControlLayout = typeof Constants.CONTROL_LAYOUTS[number];
export type ButtonTheme = typeof Constants.BUTTON_THEMES[number];
export type PopoverTrigger = typeof Constants.POPOVER_TRIGGERS[number];
export type PopupPosition = typeof Constants.POPUP_POSITIONS[number];
export type PopupVAlign = typeof

  Constants.POPUP_VALIGNS[number];
export type PopupAlign = typeof Constants.POPUP_ALIGNS[number];
